import { render, staticRenderFns } from "./land-location.vue?vue&type=template&id=847fe4d4&"
import script from "./land-location.vue?vue&type=script&lang=js&"
export * from "./land-location.vue?vue&type=script&lang=js&"
import style0 from "./land-location.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports